import React from 'react';
import {
  AppBar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Paper,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { LaunchRounded } from '@material-ui/icons';
import { useIsExtensionWidth } from '../utils/utils';
import { useNavigate } from 'react-router-dom';

// App list of offical Domi Chain apps and/or Partners
const OFFICIAL_DAPPS = [
  {
    name: 'Sesame Swap',
    url: 'https://sesameswap.com/',
    description: 'Decentralized exchange',
  },
  {
    name: 'Sesame Order',
    url: 'https://order.sesameswap.com/',
    description: 'Order management platform',
  },
];

const ICON_SIZE = 28;

const useStyles = makeStyles((theme) => ({
  listItemIcon: {
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: ICON_SIZE,
    width: ICON_SIZE,
    borderRadius: ICON_SIZE / 2,
    color: 'white',
  },
  listItem: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    cursor: 'pointer',
  },
}));

export default function OfficialDappsList() {
  const classes = useStyles();
  const isExtensionWidth = useIsExtensionWidth();
  const navigate = useNavigate();

  const handleDappClick = (url) => {
    // Navigate to browser page with the URL passed as state
    navigate('/browser', { state: { url } });
  };

  return (
    <Paper style={{ marginBottom: isExtensionWidth ? 0 : 24 }}>
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar>
          <Typography
            variant="h6"
            style={{ flexGrow: 1, fontSize: isExtensionWidth && '1rem' }}
            component="h2"
          >
            Official Dapps
          </Typography>
        </Toolbar>
      </AppBar>
      <List disablePadding>
        {OFFICIAL_DAPPS.map((dapp, index) => (
          <ListItem
            key={index}
            className={classes.listItem}
            onClick={() => handleDappClick(dapp.url)}
          >
            <ListItemIcon>
              <div className={classes.listItemIcon}>
                <LaunchRounded fontSize="small" />
              </div>
            </ListItemIcon>
            <ListItemText 
              primary={dapp.name} 
              secondary={dapp.description}
            />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}